<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">FocusPay Devices</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideSave]="true"
				[hideDelete]="true"
				(onAddChange)="addDevice()"
				[addDisabled]="userService.userSubscription.value.role < 5"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="deviceList"
		[loading]="!deviceList"
		[globalFilterFields]="app.keys(deviceList)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="type">
					<div class="d-flex w-100">
						Type
						<p-sortIcon field="type"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter
								field="type"
								matchMode="in"
								display="menu"
								[showMatchModes]="false"
								[showOperator]="false"
								[showAddButton]="false"
								class="ms-auto"
							>
								<ng-template pTemplate="header">
									<div class="px-3 pt-3 pb-0">
										<span class="font-bold">Device Type</span>
									</div>
								</ng-template>
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-multiSelect
										[ngModel]="value"
										[options]="app.references.focusPayDeviceTypes"
										placeholder="Any"
										optionLabel="label"
										optionValue="value"
										(onChange)="filter($event.value)"
									>
									</p-multiSelect>
								</ng-template>
							</p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="key">
					<div class="d-flex w-100">
						Serial Number
						<p-sortIcon field="key"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="key" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="venueAssignment">
					<div class="d-flex w-100">
						Assigned Venue
						<p-sortIcon field="venueAssignment"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="venueAssignment" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="created">
					<div class="d-flex w-100">
						Created
						<p-sortIcon field="created"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="date" field="created" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="ipAddress">
					<div class="d-flex w-100">
						IP Address
						<p-sortIcon field="ipAddress"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="ipAddress" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="deviceSelected = rec">
				<td>
					{{ rec.type }}
				</td>
				<td>
					{{ rec.key }}
				</td>
				<td>
					{{ rec.venueAssignment || rec.venueKey || "unassigned" }}
				</td>
				<td>
					{{ app.moment(rec.created).format("l LT") }}
				</td>
				<td>
					{{ rec.ipAddress || "no IP found" }}
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td [colSpan]="dt.columns.length">
					<p-message severity="info">
						<p>No devices found.</p>
					</p-message>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-device-management
	*ngIf="deviceSelected"
	[(device)]="deviceSelected"
	(onDeviceDeleteChange)="onDelete($event)"
	(onSaveChange)="onSave($event)"
></app-device-management>
